// Automatically generated file. Do not edit. Do not commit.
// (generated by gulpfile during build)
export const emulators = {};
import { Alfatron } from '../emulators/Alfatron';
emulators.Alfatron = Alfatron;
import { Alfatron21e } from '../emulators/Alfatron21e';
emulators.Alfatron21e = Alfatron21e;
import { AlfatronAmp } from '../emulators/AlfatronAmp';
emulators.AlfatronAmp = AlfatronAmp;
import { AlfatronDspTcp } from '../emulators/AlfatronDspTcp';
emulators.AlfatronDspTcp = AlfatronDspTcp;
import { AlfatronDspUdp } from '../emulators/AlfatronDspUdp';
emulators.AlfatronDspUdp = AlfatronDspUdp;
import { AlfatronMuheGen2 } from '../emulators/AlfatronMuheGen2';
emulators.AlfatronMuheGen2 = AlfatronMuheGen2;
import { AlfatronMukn } from '../emulators/AlfatronMukn';
emulators.AlfatronMukn = AlfatronMukn;
import { AlfatronSck41 } from '../emulators/AlfatronSck41';
emulators.AlfatronSck41 = AlfatronSck41;
import { AlfatronSck51 } from '../emulators/AlfatronSck51';
emulators.AlfatronSck51 = AlfatronSck51;
import { AlfatronScu61e } from '../emulators/AlfatronScu61e';
emulators.AlfatronScu61e = AlfatronScu61e;
import { AlfatronSmw42 } from '../emulators/AlfatronSmw42';
emulators.AlfatronSmw42 = AlfatronSmw42;
import { AlfatronWu4k } from '../emulators/AlfatronWu4k';
emulators.AlfatronWu4k = AlfatronWu4k;
import { Aneuvideo } from '../emulators/Aneuvideo';
emulators.Aneuvideo = Aneuvideo;
import { AshlyMxaDsp } from '../emulators/AshlyMxaDsp';
emulators.AshlyMxaDsp = AshlyMxaDsp;
import { AshlyNeDsp } from '../emulators/AshlyNeDsp';
emulators.AshlyNeDsp = AshlyNeDsp;
import { Atdm0604 } from '../emulators/Atdm0604';
emulators.Atdm0604 = Atdm0604;
import { AtenUsb } from '../emulators/AtenUsb';
emulators.AtenUsb = AtenUsb;
import { AtenVideoSwitcher } from '../emulators/AtenVideoSwitcher';
emulators.AtenVideoSwitcher = AtenVideoSwitcher;
import { Atlona } from '../emulators/Atlona';
emulators.Atlona = Atlona;
import { AtlonaAmp } from '../emulators/AtlonaAmp';
emulators.AtlonaAmp = AtlonaAmp;
import { AtlonaMs52w } from '../emulators/AtlonaMs52w';
emulators.AtlonaMs52w = AtlonaMs52w;
import { AutomateVx } from '../emulators/AutomateVx';
emulators.AutomateVx = AutomateVx;
import { AvProMxNet } from '../emulators/AvProMxNet';
emulators.AvProMxNet = AvProMxNet;
import { AvProSwitcher } from '../emulators/AvProSwitcher';
emulators.AvProSwitcher = AvProSwitcher;
import { AveoUniversalApiV1 } from '../emulators/AveoUniversalApiV1';
emulators.AveoUniversalApiV1 = AveoUniversalApiV1;
import { Avocor } from '../emulators/Avocor';
emulators.Avocor = Avocor;
import { BarcoClickShare } from '../emulators/BarcoClickShare';
emulators.BarcoClickShare = BarcoClickShare;
import { BenQInteractiveFlatPanel } from '../emulators/BenQInteractiveFlatPanel';
emulators.BenQInteractiveFlatPanel = BenQInteractiveFlatPanel;
import { BenQProjector } from '../emulators/BenQProjector';
emulators.BenQProjector = BenQProjector;
import { BinaryMoip } from '../emulators/BinaryMoip';
emulators.BinaryMoip = BinaryMoip;
import { Blackbox } from '../emulators/Blackbox';
emulators.Blackbox = Blackbox;
import { Blackmagic } from '../emulators/Blackmagic';
emulators.Blackmagic = Blackmagic;
import { Blustream } from '../emulators/Blustream';
emulators.Blustream = Blustream;
import { BlustreamAcm200 } from '../emulators/BlustreamAcm200';
emulators.BlustreamAcm200 = BlustreamAcm200;
import { BoseVideoBar } from '../emulators/BoseVideoBar';
emulators.BoseVideoBar = BoseVideoBar;
import { ChristieGsSeries } from '../emulators/ChristieGsSeries';
emulators.ChristieGsSeries = ChristieGsSeries;
import { ChristieSecure } from '../emulators/ChristieSecure';
emulators.ChristieSecure = ChristieSecure;
import { CiscoTelepresence } from '../emulators/CiscoTelepresence';
emulators.CiscoTelepresence = CiscoTelepresence;
import { ContemporaryResearch } from '../emulators/ContemporaryResearch';
emulators.ContemporaryResearch = ContemporaryResearch;
import { ControlByWebX400 } from '../emulators/ControlByWebX400';
emulators.ControlByWebX400 = ControlByWebX400;
import { ConvergePro2 } from '../emulators/ConvergePro2';
emulators.ConvergePro2 = ConvergePro2;
import { Datapath } from '../emulators/Datapath';
emulators.Datapath = Datapath;
import { Denon500BD } from '../emulators/Denon500BD';
emulators.Denon500BD = Denon500BD;
import { Denon900R } from '../emulators/Denon900R';
emulators.Denon900R = Denon900R;
import { DenonAvr } from '../emulators/DenonAvr';
emulators.DenonAvr = DenonAvr;
import { DigitalProjection } from '../emulators/DigitalProjection';
emulators.DigitalProjection = DigitalProjection;
import { DirectvNetwork } from '../emulators/DirectvNetwork';
emulators.DirectvNetwork = DirectvNetwork;
import { Dm8000 } from '../emulators/Dm8000';
emulators.Dm8000 = Dm8000;
import { Dten } from '../emulators/Dten';
emulators.Dten = Dten;
import { EclerVida } from '../emulators/EclerVida';
emulators.EclerVida = EclerVida;
import { Epiphan } from '../emulators/Epiphan';
emulators.Epiphan = Epiphan;
import { EpsonVp21 } from '../emulators/EpsonVp21';
emulators.EpsonVp21 = EpsonVp21;
import { Extron } from '../emulators/Extron';
emulators.Extron = Extron;
import { ForTheRecord } from '../emulators/ForTheRecord';
emulators.ForTheRecord = ForTheRecord;
import { FsrDvHsw } from '../emulators/FsrDvHsw';
emulators.FsrDvHsw = FsrDvHsw;
import { FsrDvT6ss } from '../emulators/FsrDvT6ss';
emulators.FsrDvT6ss = FsrDvT6ss;
import { FsrV1 } from '../emulators/FsrV1';
emulators.FsrV1 = FsrV1;
import { GlobalCache } from '../emulators/GlobalCache';
emulators.GlobalCache = GlobalCache;
import { HallResearchEmcee } from '../emulators/HallResearchEmcee';
emulators.HallResearchEmcee = HallResearchEmcee;
import { HallResearchHsm } from '../emulators/HallResearchHsm';
emulators.HallResearchHsm = HallResearchHsm;
import { HallResearchSc } from '../emulators/HallResearchSc';
emulators.HallResearchSc = HallResearchSc;
import { HallResearchSw } from '../emulators/HallResearchSw';
emulators.HallResearchSw = HallResearchSw;
import { HitachiProjector } from '../emulators/HitachiProjector';
emulators.HitachiProjector = HitachiProjector;
import { I3TouchEx } from '../emulators/I3TouchEx';
emulators.I3TouchEx = I3TouchEx;
import { I3TouchXOne } from '../emulators/I3TouchXOne';
emulators.I3TouchXOne = I3TouchXOne;
import { InogeniCam230 } from '../emulators/InogeniCam230';
emulators.InogeniCam230 = InogeniCam230;
import { InogeniCam300 } from '../emulators/InogeniCam300';
emulators.InogeniCam300 = InogeniCam300;
import { InogeniShare2u } from '../emulators/InogeniShare2u';
emulators.InogeniShare2u = InogeniShare2u;
import { InogeniUsbToggle } from '../emulators/InogeniUsbToggle';
emulators.InogeniUsbToggle = InogeniUsbToggle;
import { Ip2Ir } from '../emulators/Ip2Ir';
emulators.Ip2Ir = Ip2Ir;
import { JblSynthesis } from '../emulators/JblSynthesis';
emulators.JblSynthesis = JblSynthesis;
import { JustAddPower } from '../emulators/JustAddPower';
emulators.JustAddPower = JustAddPower;
import { JustAddPowerAmp } from '../emulators/JustAddPowerAmp';
emulators.JustAddPowerAmp = JustAddPowerAmp;
import { KanexPro } from '../emulators/KanexPro';
emulators.KanexPro = KanexPro;
import { Kramer } from '../emulators/Kramer';
emulators.Kramer = Kramer;
import { LG } from '../emulators/LG';
emulators.LG = LG;
import { Lencore } from '../emulators/Lencore';
emulators.Lencore = Lencore;
import { LgDigitalSignage } from '../emulators/LgDigitalSignage';
emulators.LgDigitalSignage = LgDigitalSignage;
import { LibertyAvDLE } from '../emulators/LibertyAvDLE';
emulators.LibertyAvDLE = LibertyAvDLE;
import { Lightware } from '../emulators/Lightware';
emulators.Lightware = Lightware;
import { LiteTouch } from '../emulators/LiteTouch';
emulators.LiteTouch = LiteTouch;
import { Lutron } from '../emulators/Lutron';
emulators.Lutron = Lutron;
import { MechoNetZgn } from '../emulators/MechoNetZgn';
emulators.MechoNetZgn = MechoNetZgn;
import { Monoprice } from '../emulators/Monoprice';
emulators.Monoprice = Monoprice;
import { NanolumensCaptivateTcp } from '../emulators/NanolumensCaptivateTcp';
emulators.NanolumensCaptivateTcp = NanolumensCaptivateTcp;
import { NanolumensCaptivateUdp } from '../emulators/NanolumensCaptivateUdp';
emulators.NanolumensCaptivateUdp = NanolumensCaptivateUdp;
import { NecMultisync } from '../emulators/NecMultisync';
emulators.NecMultisync = NecMultisync;
import { NecProjector } from '../emulators/NecProjector';
emulators.NecProjector = NecProjector;
import { Netvio } from '../emulators/Netvio';
emulators.Netvio = Netvio;
import { NovastarHSeriesTcp } from '../emulators/NovastarHSeriesTcp';
emulators.NovastarHSeriesTcp = NovastarHSeriesTcp;
import { NovastarHSeriesUdp } from '../emulators/NovastarHSeriesUdp';
emulators.NovastarHSeriesUdp = NovastarHSeriesUdp;
import { NovastarVxSeries } from '../emulators/NovastarVxSeries';
emulators.NovastarVxSeries = NovastarVxSeries;
import { NovoTouch } from '../emulators/NovoTouch';
emulators.NovoTouch = NovoTouch;
import { Nureva } from '../emulators/Nureva';
emulators.Nureva = Nureva;
import { OnkyoRz } from '../emulators/OnkyoRz';
emulators.OnkyoRz = OnkyoRz;
import { OptomaWuProjector } from '../emulators/OptomaWuProjector';
emulators.OptomaWuProjector = OptomaWuProjector;
import { OreiMatrix } from '../emulators/OreiMatrix';
emulators.OreiMatrix = OreiMatrix;
import { P300 } from '../emulators/P300';
emulators.P300 = P300;
import { PanasonicCamera } from '../emulators/PanasonicCamera';
emulators.PanasonicCamera = PanasonicCamera;
import { PanasonicDisplayRs232 } from '../emulators/PanasonicDisplayRs232';
emulators.PanasonicDisplayRs232 = PanasonicDisplayRs232;
import { PanasonicDisplayTelnet } from '../emulators/PanasonicDisplayTelnet';
emulators.PanasonicDisplayTelnet = PanasonicDisplayTelnet;
import { PanasonicProjectorRs232 } from '../emulators/PanasonicProjectorRs232';
emulators.PanasonicProjectorRs232 = PanasonicProjectorRs232;
import { PanasonicProjectorTelnet } from '../emulators/PanasonicProjectorTelnet';
emulators.PanasonicProjectorTelnet = PanasonicProjectorTelnet;
import { PensarLed } from '../emulators/PensarLed';
emulators.PensarLed = PensarLed;
import { Philips } from '../emulators/Philips';
emulators.Philips = Philips;
import { Pjlink } from '../emulators/Pjlink';
emulators.Pjlink = Pjlink;
import { PlanarHbSeries } from '../emulators/PlanarHbSeries';
emulators.PlanarHbSeries = PlanarHbSeries;
import { PlanarMSeries } from '../emulators/PlanarMSeries';
emulators.PlanarMSeries = PlanarMSeries;
import { PlanarVideoController } from '../emulators/PlanarVideoController';
emulators.PlanarVideoController = PlanarVideoController;
import { PureLink } from '../emulators/PureLink';
emulators.PureLink = PureLink;
import { QSys } from '../emulators/QSys';
emulators.QSys = QSys;
import { Radius } from '../emulators/Radius';
emulators.Radius = Radius;
import { Roku } from '../emulators/Roku';
emulators.Roku = Roku;
import { SamsungPro } from '../emulators/SamsungPro';
emulators.SamsungPro = SamsungPro;
import { SamsungProTv } from '../emulators/SamsungProTv';
emulators.SamsungProTv = SamsungProTv;
import { SceptreIr } from '../emulators/SceptreIr';
emulators.SceptreIr = SceptreIr;
import { SharpAquos } from '../emulators/SharpAquos';
emulators.SharpAquos = SharpAquos;
import { SharpPnuh } from '../emulators/SharpPnuh';
emulators.SharpPnuh = SharpPnuh;
import { SmartBoard } from '../emulators/SmartBoard';
emulators.SmartBoard = SmartBoard;
import { SonyBravia } from '../emulators/SonyBravia';
emulators.SonyBravia = SonyBravia;
import { SonyBraviaIr } from '../emulators/SonyBraviaIr';
emulators.SonyBraviaIr = SonyBraviaIr;
import { SonyBraviaRs232 } from '../emulators/SonyBraviaRs232';
emulators.SonyBraviaRs232 = SonyBraviaRs232;
import { SonyVplProjector } from '../emulators/SonyVplProjector';
emulators.SonyVplProjector = SonyVplProjector;
import { SoundStructure } from '../emulators/SoundStructure';
emulators.SoundStructure = SoundStructure;
import { StewartAudio } from '../emulators/StewartAudio';
emulators.StewartAudio = StewartAudio;
import { StewartAudioFlxE } from '../emulators/StewartAudioFlxE';
emulators.StewartAudioFlxE = StewartAudioFlxE;
import { Sunbrite } from '../emulators/Sunbrite';
emulators.Sunbrite = Sunbrite;
import { TclIr } from '../emulators/TclIr';
emulators.TclIr = TclIr;
import { Tesira } from '../emulators/Tesira';
emulators.Tesira = Tesira;
import { Tivo } from '../emulators/Tivo';
emulators.Tivo = Tivo;
import { ToaAmCf1 } from '../emulators/ToaAmCf1';
emulators.ToaAmCf1 = ToaAmCf1;
import { USwitch } from '../emulators/USwitch';
emulators.USwitch = USwitch;
import { VaddioCamera } from '../emulators/VaddioCamera';
emulators.VaddioCamera = VaddioCamera;
import { ViewSonicViewBoard } from '../emulators/ViewSonicViewBoard';
emulators.ViewSonicViewBoard = ViewSonicViewBoard;
import { VirtualDisplay } from '../emulators/VirtualDisplay';
emulators.VirtualDisplay = VirtualDisplay;
import { ViscaTcp } from '../emulators/ViscaTcp';
emulators.ViscaTcp = ViscaTcp;
import { ViscaUdp } from '../emulators/ViscaUdp';
emulators.ViscaUdp = ViscaUdp;
import { VisionarySolutions } from '../emulators/VisionarySolutions';
emulators.VisionarySolutions = VisionarySolutions;
import { VivitekProjector3and4Series } from '../emulators/VivitekProjector3and4Series';
emulators.VivitekProjector3and4Series = VivitekProjector3and4Series;
import { VivitekProjector7000 } from '../emulators/VivitekProjector7000';
emulators.VivitekProjector7000 = VivitekProjector7000;
import { WolfVisionCynap } from '../emulators/WolfVisionCynap';
emulators.WolfVisionCynap = WolfVisionCynap;
import { WyreStormSw130Tx } from '../emulators/WyreStormSw130Tx';
emulators.WyreStormSw130Tx = WyreStormSw130Tx;
import { WyreStormSw740Tx } from '../emulators/WyreStormSw740Tx';
emulators.WyreStormSw740Tx = WyreStormSw740Tx;
import { Xantech } from '../emulators/Xantech';
emulators.Xantech = Xantech;
import { XilicaSolaro } from '../emulators/XilicaSolaro';
emulators.XilicaSolaro = XilicaSolaro;
import { Yamaha } from '../emulators/Yamaha';
emulators.Yamaha = Yamaha;
import { YamahaAdecia } from '../emulators/YamahaAdecia';
emulators.YamahaAdecia = YamahaAdecia;
import { YamahaMtx } from '../emulators/YamahaMtx';
emulators.YamahaMtx = YamahaMtx;
import { Yinker } from '../emulators/Yinker';
emulators.Yinker = Yinker;
import { ZeeVee } from '../emulators/ZeeVee';
emulators.ZeeVee = ZeeVee;
import { Zoom } from '../emulators/Zoom';
emulators.Zoom = Zoom;
